import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const SmartphoneIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <path d="M12 18h.01" />
  </ChakraIcon>
)

export default SmartphoneIcon
